import React from 'react'
import {Table, TableBody, TableHead, TableRow, withStyles} from '@material-ui/core';
import styles from './styles'
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import classNames from 'classnames'
import {
  Pagination,
  Portlet,
  PortletContent,
  TableCellWithConfig,
  TableSettings,
  TextPlaceholderWrapper
} from '../../index'
import useTablePagination from '../../../hooks/useTablePagination';
import useTableConfig from '../../../hooks/useTableConfig';
import DefaultConfig from './config';
import {getTableKey} from '../../../services/util/tableConfigHelper';
import {TableKind} from '../../../services/enums/TableKind';
import Columns from './columns';
import {displayModes} from '../../../services/enums/displayModes';

function DriverTable(props) {

  const {
    classes,
    className,
    drivers,
    t,
    selectDriver,
    displayDriverTypes,
    deleteDriver,
    selectedDriver,
    tableDisplayMode
  } = props;

  const {
    config,
    columnConfigs,
    updateConfig
  } = useTableConfig(
    DefaultConfig,
    tableDisplayMode,
    getTableKey(TableKind.DriverTable, tableDisplayMode),
  )

  const rootClassName = classNames(classes.root, className);

  const {paginationProps, pagedObjects} = useTablePagination(drivers);

  return (
    <TextPlaceholderWrapper
      active={!drivers?.length}
      text={t('noDriversFound')}
    >
      <Portlet className={rootClassName}>
        <PortletContent noPadding>
          <TableSettings
            updateConfig={updateConfig}
            tableConfig={config}
            columns={Columns}
            useNamesAsTranslateString
          />
          <Table size="medium">
            <TableHead>
              <TableRow>
                {columnConfigs.map(columnConfig => (
                  <TableCellWithConfig
                    key={columnConfig.order}
                    config={columnConfig}
                  >
                    {Columns[columnConfig.columnName].header({t, classes})}
                  </TableCellWithConfig>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {pagedObjects.map((driver, index) => (
                <TableRow
                  className={classNames(classes.tableRow, 'cursorPointer')}
                  hover
                  key={index}
                  onClick={() => selectDriver(driver)}
                  selected={selectedDriver && selectedDriver.id === driver.id}
                >
                  {columnConfigs.map(columnConfig => (
                    <TableCellWithConfig
                      key={columnConfig.order}
                      config={columnConfig}
                      className={classes.tableCell}
                    >
                      {Columns[columnConfig.columnName].body({
                        driver, classes, deleteDriver, t, displayDriverTypes
                      })}
                    </TableCellWithConfig>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Pagination paginationProps={paginationProps}/>
        </PortletContent>
      </Portlet>
    </TextPlaceholderWrapper>
  );
}


DriverTable.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  deleteDriver: PropTypes.func,
  displayDriverTypes: PropTypes.func.isRequired,
  drivers: PropTypes.array.isRequired,
  selectDriver: PropTypes.func.isRequired,
  selectedDriver: PropTypes.object,
  t: PropTypes.func.isRequired,
  tableDisplayMode: PropTypes.oneOf(Object.values(displayModes)).isRequired,
};

DriverTable.defaultProps = {
  drivers: [],
};


export default compose(withStyles(styles), withTranslation())(DriverTable);
